import * as LocalAuthentication from "expo-local-authentication";

const checkBiometricAvailability = async () => {
  const isHardwareAvailable = await LocalAuthentication.hasHardwareAsync();
  const isEnrolled = await LocalAuthentication.isEnrolledAsync();

  return isHardwareAvailable && isEnrolled;
};

const handleBiometricLogin = async () => {
  try {
    const result = await LocalAuthentication.authenticateAsync({
      promptMessage: "Authenticate to login",
    });
    if (result.success) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Biometric authentication error", error);
  }
};

export { checkBiometricAvailability, handleBiometricLogin };
